import { render } from "./VerPacientes.vue?vue&type=template&id=061c3e54"
import script from "./VerPacientes.vue?vue&type=script&lang=js"
export * from "./VerPacientes.vue?vue&type=script&lang=js"

import "./VerPacientes.vue?vue&type=style&index=0&id=061c3e54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__